export default [
  {
    path: '/admin/trader/edges',
    name: 'Edges',
    component: () => import('@/views/Admin/Trader/Edges/Index.vue'),
    meta: {
      pageTitle: 'Edge Library',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Edges', active: true },
      ],
      resource: 'edges.list',
      action: 'read',
    },
  },
]
